// third-party

import { NavItemType } from "types";

import * as RouteHelper from "@utils/routes";

import TrackChanges from "@mui/icons-material/TrackChanges";
import Engineering from "@mui/icons-material/Engineering";
import { useTheme } from "@mui/material";

export const getPackageNav = (projectId: string): NavItemType => {
  const theme = useTheme();
  return {
    id: "packages",
    title: "Package",
    icon: <TrackChanges sx={{ color: theme.palette.primary.main }} />,
    type: "group",
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        type: "item",
        icon: <TrackChanges sx={{ color: theme.palette.primary.main }} />,
        url: RouteHelper.contractorDashboard(projectId),
      },
      {
        id: "packages",
        title: "Subcontractors",
        type: "item",
        icon: <Engineering sx={{ color: theme.palette.primary.main }} />,
        url: RouteHelper.packages(projectId),
      },
    ],
  };
};

export const getReducedPackageNav = (projectId: string): NavItemType => {
  const theme = useTheme();
  return {
    id: "packages",
    title: "Package",
    icon: <TrackChanges sx={{ color: theme.palette.primary.main }} />,
    type: "group",
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        type: "item",
        icon: <TrackChanges sx={{ color: theme.palette.primary.main }} />,
        url: RouteHelper.contractorDashboard(projectId),
      },
    ],
  };
};
